module.exports = __webpack_public_path__ + "assets/img/59@3x.4823176b.png";